import { connect } from 'react-redux'
import StreamerCards from './StreamerCards'
import { fetchStreamerCards } from './streamerCardsActions'

// Applies filtering to active streams loaded from the server
const mapStateToProps = state => {
  const selectedCategories = state.topPanel.categories.filter((c) => c.isSelected)
    .map(category => category.id)
  let streamers = [...state.streamerCards.streamers]

  // If no category is checked, no filtering is performed
  if (selectedCategories.length > 0) {
    let i = 0
    while (i < streamers.length) {
      let streamsCategoriesIds = streamers[i].activeStreams.map(stream => stream.categoryId)
      if (!streamsCategoriesIds.some(id => selectedCategories.includes(id))) {
        streamers.splice(i, 1)
      } else {
        ++i
      }
    }
  }

  // filtering by the search text
  const searchText = state.topPanel.searchText.toLowerCase()
  if (searchText !== '') {
    streamers = streamers.filter(streamer => streamer.name.toLowerCase().includes(searchText) ||
      streamer.activeStreams.filter(stream => stream.title.toLowerCase().includes(searchText)).length > 0)
  }

  return {
    streamers: streamers
  }
}

const mapDispatchToProps = dispatch => ({
  fetchStreamerCards: () => (dispatch(fetchStreamerCards()))
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps
})

// Object-container for stateless component StreamerCards
const StreamerCardsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(StreamerCards)
export default StreamerCardsContainer
